export default __webpack_public_path__ + "static/11-1a9a000b9eb99126aec232331e4e508c.jpg";